import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import {
  getPyqTopicWiseRequest,
  fetchSubjectListRequest,
  getPyqSubjectWiseRequest,
  setActiveSubject,
  setSelectedTopic,
} from "../../../../../redux/exam/examSlice";
import "./PyqTopicWise.css";
import images from "../../../../../utilities/images/images";

const PyqTopicWise = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading } = useSelector((state) => state.examSlice);
  // const { classId, courseId } = useSelector((state) => state.userActivity);
 
  const { pyqTopicWiseSubjects, subjectList,pyqSubjectWiseTopics, activeSubject , plannerDetails} =
    useSelector((state) => state.examSlice);
const paper_type = plannerDetails?.id;
const isExamCrackerFlow = Number(paper_type) === 8 || Number(paper_type) === 9;
  // useEffect(() => {
  //   dispatch(
  //     getPyqTopicWiseRequest({ course_id: courseId, class_id: classId })
  //   );
  // }, [dispatch]);
useEffect(() => {
  if (paper_type) {
    dispatch(
      fetchSubjectListRequest({
        category_id: paper_type,
      })
    );
  }
}, [dispatch, paper_type]);
  useEffect(() => {
    if (activeSubject&& paper_type) {
      dispatch(getPyqSubjectWiseRequest({ subject: activeSubject,paper_type }));
    }
  }, [dispatch, activeSubject,paper_type]);

  const handleSubjectChange = (subjectName) => {
    dispatch(setActiveSubject(subjectName));
  };
useEffect(() => {
  if (subjectList?.length > 0 && !activeSubject) {
    const firstSubject = subjectList.find(
      (sub) => sub.sub_name !== "Information"
    );

    if (firstSubject) {
      dispatch(setActiveSubject(firstSubject.sub_name));
    }
  }
}, [subjectList, activeSubject, dispatch]);
  const handleTopicSelect = (topicId) => {
    const selectedTopic = pyqSubjectWiseTopics.find(
      (topic) => topic.topic_id === topicId
    );
    dispatch(setSelectedTopic(selectedTopic));
    history.push("/practice/topic-wise/pyqset");
  };

  return (
    <div className="topic-wise-container">
      <div className="topic-wise-header">
        <img
          style={{
            marginLeft: "25px",
            width: "24px",
            height: "24px",
            cursor: "pointer",
          }}
          src={images.new_backarrow}
          alt="Back"
          onClick={() => history.push("/practice")}
        />
        <h3 id="practice-wise">
          {isExamCrackerFlow ? "Exam Cracker" : "Topic Wise Practice"}
        </h3>
      </div>

      <div className="subject-tabs">
        {subjectList
          ?.filter((sub) => sub.sub_name !== "Information")
          .map((sub) => (
            <div
              key={sub.sub_id}
              className={`subject-tab ${activeSubject === sub.sub_name ? "active" : ""
                }`}
              onClick={() => handleSubjectChange(sub.sub_name)}
              style={{
                color: activeSubject === sub.sub_name ? sub.text_color : "#888",
              }}
            >
              <img src={sub.icon} alt={sub.sub_name} />
              <span>{sub.sub_name}</span>
                 <span
        className={`progress-badge ${
          activeSubject === sub.sub_name ? "active-badge" : ""
        }`}
      >
        {sub.progress_percent || 0}%
      </span>
            </div>
          ))}
      </div>
{loading ? (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "60vh",
    }}
  >
    <ClipLoader size={40} color="#C61C26" />
  </div>
) : (
      <div className="topic-grid">
        {pyqSubjectWiseTopics?.map((topic) => (
          <div
            className="topic-card"
            key={topic.topic_id}
            onClick={() => handleTopicSelect(topic.topic_id)}
            style={{ cursor: "pointer" }}
          >
            <div className="topic-left">
              <img src={topic.icon} alt={topic.topic_name} />
              <div>
                <h4>{topic.topic_name}</h4>
                {/* <p>{`0/${topic.total_questions} Sets`}</p> */}
              </div>
            </div>

            <div className="topic-progress">
              <svg viewBox="0 0 36 36">
                <path
                  className="circle-bg"
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <path
                  className="circle"
                  // strokeDasharray={` 100`}
                   strokeDasharray={`${topic.progress_percent || 0}, 100`}
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <text x="18" y="20.35" className="percentage">
                  {/* {0}% */}
                  {topic.progress_percent || 0}%
                </text>
              </svg>
            </div>
          </div>
        ))}
      </div>)}
    </div>
  );
};

export default PyqTopicWise;
